import React, { useState, useEffect,useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Otp = ({ onClose, otpSend, login, resendOtp, resendSignupOtp }) => {
  const [otp, setOtp] = useState(Array(login ? 4 : 6).fill(""));
  const [validOtp, setValidOtp] = useState("");
  const [resendDisabled, setResendDisabled] = useState(true);
  const [timer, setTimer] = useState(30);

  const inputRef=useRef([]);

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (!/^[0-9]?$/.test(value)) return; 

    const newOtp = [...otp];
    newOtp[index] = value;
    let newOtpValid = ""
    for (let i of newOtp) {
      console.log(i)
      newOtpValid += i;
    }
    if(index < otp.length - 1 && value){
      inputRef.current[index + 1].focus();
    }
    
    setOtp(newOtp);
    setValidOtp(newOtpValid);
    // Move focus to next input if a digit is entered
    

  };

  const handleKeyDown=(index, event)=>{
    if(event.key === 'Backspace' && index > 0 && !otp[index]){
      inputRef.current[index - 1].focus();
    } 
  }

  const handleSubmite = () => {
    otpSend(validOtp)
  }
  // const handleResendOtp = async () => {
  //   if (isEmail(loginInput) || isMobile(loginInput)) {
  //     setResendDisabled(true);
  //     try {
  //       // await fetchLogin();
  //       toast.info("OTP resent successfully!");
  //     } catch (error) {
  //       console.error("Error in resending OTP: ", error);
  //       toast.error("Error in resending OTP. Please try again later.");
  //     }
  //     setTimeout(() => setResendDisabled(false), 20000);
  //   } else {
  //     toast.warning("Please enter a valid email or 10-digit mobile number");
  //   }
  // };

  useEffect(() => {
    if (resendDisabled) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setResendDisabled(false); 
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [resendDisabled]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-lg relative">

        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-xl font-semibold">Authenticate</h2>
          {/* <button onClick={()=>{onClose()}} className="text-2xl">✖</button> */}
        </div>

        {/* OTP Message */}
        <p className="mt-4 text-gray-700">
          Enter the 4-digit OTP sent to your phone number{" "}
          <span className="font-semibold">+91xxxxxxx</span>
        </p>
        <p className="py-3">Enter OTP</p>

        {/* OTP Input Fields */}
        <div className="flex justify-center gap-4 my-4">
          {otp.map((digit, i) => (
            <input
              key={i}
              id={`otp-input-${i}`}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(i, e)}
              ref={(el)=>{ inputRef.current[i] = el}}
              onKeyDown={(e) => {handleKeyDown(i, e)}}
              className="w-10 h-11 border border-gray-300 text-center text-lg rounded-xl"
            />
          ))}
        </div>

        {/* Resend OTP */}
        <div className="text-sm text-gray-500 flex justify-between">
          <button
          
            onClick={() => {
              if (login) {
                resendOtp(); 
              } else {
                resendSignupOtp(); 
              }
              setResendDisabled(true);
              setTimer(30);
            }}
            disabled={resendDisabled}
            className={` mt-3  transition ${resendDisabled
              ? "text-gray-600 cursor-not-allowed"
              : "text-blue-500"
              }`}
          > {resendDisabled ? `Resend OTP (${timer}s)` : `Resend OTP`}
          </button>
        </div>
        {/* Footer Message */}
        <p className="text-gray-500 text-sm mt-3">
          This authentication is valid for the current session only.
        </p>

        {/* Buttons */}
        <div className="flex justify-between mt-4">
          <button onClick={()=>{onClose()}} className="text-purple-600">Cancel</button>
          <button
            className={`px-4 py-2 rounded text-white ${otp.includes("") ? "bg-gray-300 cursor-not-allowed" : "bg-purple-600"
              }`}
            disabled={otp.includes("")} // Disable confirm if OTP is incomplete
            onClick={handleSubmite}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default Otp;